import {useNavigate, useSearchParams} from "react-router-dom";
import {useModal} from "../../../../hooks/hooks";
import {useCallback} from "react";
import {TermsCategory} from "../../../../types/terms";

export function useOrderFunctions() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { openAlertModal } = useModal();

    function getCartIdxesFromQueryParam(): number[] {
        const cartIdxes =
            searchParams
                .get("cart-idxes")
                ?.split(",")
                ?.map((it) => parseInt(it)) ?? [];
        if (cartIdxes.length === 0) {
            openAlertModal({
                title: "안내",
                desc: "잘못된 접근입니다.",
            });
            navigate(`/purchase-voucher`);
            return [];
        }

        return cartIdxes;
    }

    // 약관 링크 처리 함수
    const onClickTermsLink = useCallback((e: React.MouseEvent) => {
        window.open(`${process.env.REACT_APP_BASE_URL}terms?terms_category=${TermsCategory.PAYMENT_TERMS}`, "_blank");
        e.stopPropagation();
    }, []);


    return {
        getCartIdxesFromQueryParam,
        onClickTermsLink,
    }
}